module.exports = __webpack_public_path__ + "img/永祥股份_1.163155cf.png";